import { motion } from "framer-motion";
import { MicroLabel } from "@/components/decor/CropMarks";
import { Target, Eye, Compass } from "lucide-react";

const PANELS = [
  {
    label: "Purpose",
    accent: "#0072CE",
    icon: Target,
    body:
      "To help businesses transform their brand presence through high-quality print media, corporate gifting, promotional products, signage, packaging, and integrated branding solutions that create lasting physical impact.",
  },
  {
    label: "Vision",
    accent: "#D6007F",
    icon: Eye,
    body:
      "To become a trusted, premium, and all-in-one brand execution partner for businesses seeking reliable print, gifting, promotional, and identity-driven solutions under one roof.",
  },
  {
    label: "Mission",
    accent: "#FFD200",
    icon: Compass,
    body:
      "To provide brands with thoughtfully executed physical and digital branding solutions through quality production, practical creativity, timely delivery, and long-term client relationships.",
  },
];

const PurposeVisionMission = () => {
  return (
    <section
      data-testid="purpose-vision-mission"
      className="relative"
      style={{ background: "#F5F1E8", paddingTop: 120, paddingBottom: 120 }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6">
          <div>
            <div className="flex items-center gap-3">
              <span style={{ width: 22, height: 1, background: "#0A0A0A", opacity: 0.7 }} />
              <span className="ko-overline" style={{ color: "#0A0A0A" }}>
                03 / Foundation
              </span>
            </div>
            <h2
              className="mt-6"
              style={{
                fontFamily: "Montserrat",
                fontWeight: 800,
                color: "#0A0A0A",
                fontSize: "clamp(36px, 5vw, 72px)",
                lineHeight: 1,
                letterSpacing: "-0.025em",
                textTransform: "uppercase",
                maxWidth: 900,
              }}
            >
              Purpose. Vision.
              <br />
              Mission.
            </h2>
          </div>
          <p
            style={{
              color: "#0A0A0A",
              maxWidth: 380,
              fontSize: 14,
              lineHeight: 1.7,
              opacity: 0.8,
            }}
          >
            Three guiding principles that shape how Krister Overseas builds, prints,
            and delivers brand presence to clients across categories.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-0">
          {PANELS.map((p, idx) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.label}
                data-testid={`pvm-card-${p.label.toLowerCase()}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.7, delay: idx * 0.12, ease: [0.22, 1, 0.36, 1] }}
                className="relative group"
                style={{
                  background: "#0A0A0A",
                  color: "#F5F1E8",
                  padding: "32px 28px 36px",
                  minHeight: 420,
                  borderRight: idx < PANELS.length - 1 ? "1px solid rgba(245,241,232,0.08)" : "none",
                }}
              >
                <span
                  aria-hidden
                  className="absolute top-0 left-0"
                  style={{ width: 36, height: 4, background: p.accent }}
                />
                <div className="flex items-start justify-between">
                  <span className="ko-overline" style={{ color: p.accent }}>
                    {String(idx + 1).padStart(2, "0")} · {p.label}
                  </span>
                  <Icon size={20} strokeWidth={1.5} color={p.accent} />
                </div>

                <h3
                  className="mt-10"
                  style={{
                    fontFamily: "Montserrat",
                    fontWeight: 800,
                    fontSize: "clamp(28px, 3vw, 42px)",
                    letterSpacing: "-0.02em",
                    lineHeight: 1,
                    textTransform: "uppercase",
                  }}
                >
                  {p.label}.
                </h3>
                <p
                  className="mt-6"
                  style={{
                    color: "#C0C0C0",
                    fontSize: 14,
                    lineHeight: 1.75,
                  }}
                >
                  {p.body}
                </p>
                <div
                  aria-hidden
                  className="absolute bottom-0 left-0 right-0"
                  style={{ height: 1, background: "rgba(245,241,232,0.1)" }}
                />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PurposeVisionMission;
